export default __webpack_public_path__ + "static/media/request.4f0cf8c8.png";